import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { StyleSheet, css } from 'aphrodite';
import PeopleIcon from '@mui/icons-material/People';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

export function DashboardStats() {
	const [stats, setStats] = useState({
		totalpatients: 0,
		totaldoctors: 0,
		patientsTreated: 0,
		appointmentsToday: 0,
	});

	useEffect(() => {
		async function fetchStats() {
			try {
				const response = await fetch('/hospital/patients/<int:pk>/');
				const data = await response.json();
				setStats(data);
			} catch (error) {
				console.error('Error fetching stats:', error);
			}
		}

		fetchStats();
		const interval = setInterval(fetchStats, 5000);

		return () => clearInterval(interval);
	}, []);

	const statItems = [
		{
			title: 'Total Patients',
			value: stats.patientsTreated,
			icon: <PeopleIcon className={css(styles.icon, styles.greenIcon)} />,
			bgColor: '#e8f5e9',
		},
		{
			title: 'Total Staff',
			value: stats.totaldoctors,
			icon: <LocalHospitalIcon className={css(styles.icon, styles.blueIcon)} />,
			bgColor: '#e3f2fd',
		},
		{
			title: 'Patients Treated',
			value: stats.patientsTreated,
			icon: <PeopleIcon className={css(styles.icon, styles.greenIcon)} />,
			bgColor: '#e8f5e9',
		},
		{
			title: "Today's Appointments",
			value: stats.appointmentsToday,
			icon: (
				<EventAvailableIcon className={css(styles.icon, styles.purpleIcon)} />
			),
			bgColor: '#f3e5f5',
		},
	];

	return (
		<Grid container spacing={3}>
			{statItems.map((stat, index) => (
				<Grid item xs={12} sm={6} md={3} key={index}>
					<div className={css(styles.card)}>
						<div className={css(styles.info)}>
							<div className={css(styles.statValue)}>{stat.value}</div>
							<div className={css(styles.statTitle)}>{stat.title}</div>
						</div>
						<div
							className={css(styles.iconWrapper)}
							style={{ backgroundColor: stat.bgColor }}
						>
							{stat.icon}
						</div>
					</div>
				</Grid>
			))}
		</Grid>
	);
}

const styles = StyleSheet.create({
	card: {
		padding: '16px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: '12px',
		backgroundColor: '#fff',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
		height: '120px',
	},
	info: {
		display: 'flex',
		flexDirection: 'column',
	},
	statValue: {
		fontSize: '24px',
		fontWeight: 'bold',
		color: '#000',
	},
	statTitle: {
		fontSize: '14px',
		color: '#757575',
	},
	iconWrapper: {
		width: '56px',
		height: '56px',
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	icon: {
		fontSize: '32px',
	},
	greenIcon: { color: '#2e7d32' },
	purpleIcon: { color: '#7b1fa2' },
	blueIcon: { color: '#42a5f5' },
});

export default DashboardStats;
